module.exports = __webpack_public_path__ + "static/media/1.fcf16024.wav";